import api from '../..'
import { IEnrolModel } from 'models/enrol.model'

export type SynchronousCourseEnrolBody = {
  id: string | number
} & Pick<IEnrolModel, 'synchronousCourseEnrol'>

const updateSynchronousCourseEnrol = (body: SynchronousCourseEnrolBody) => {
  const { id } = body
  return api.put(
    `administration/applications/${id}/synchronous_course_enrol`,
    body
  )
}

export default updateSynchronousCourseEnrol
